// Copyright (c) 2017 Deere & Company

/* eslint-disable complexity, max-params */

export const buildRegistrationPayload = (facets, exportToExcel, language, layout = '', listId = '') => ({
    accounts: facets.dealerAccountsFacet.selectedDealers.map(dealer => dealer.account),
    deliveryDateFrom: facets.deliveryDateRange.dateRange.from,
    deliveryDateTo: facets.deliveryDateRange.dateRange.to,
    export: exportToExcel,
    language,
    layout,
    listId,
    registrationDateFrom: facets.registrationDateRange.dateRange.from,
    registrationDateTo: facets.registrationDateRange.dateRange.to
});

/* eslint-enable complexity, max-params */



// WEBPACK FOOTER //
// ./src/product/shared/services/build-registration-payload.js